import { AudiencePage } from "@/components/audience-page";
import { FOR_FREELANCERS_FAQ_KEYS } from "@/pages/for-freelancers-content";

export function ForFreelancersComponent() {
  return (
    <AudiencePage audience="freelancers" faqs={FOR_FREELANCERS_FAQ_KEYS} />
  );
}
